<shared-modal [modalTitle]="modalTitle" [showFooter]="false" [modalClass]="customModalClass">
  <div modalBody>
    @if (contentComponent) {
      <ng-container *ngComponentOutlet="contentComponent; inputs: contentInputs" />
    } @else {
      <ng-content></ng-content>
    }
  </div>
</shared-modal>
